module.exports = __webpack_public_path__ + "img/knewidea3.ed00deb4.png";